import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca87194a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca87194a')) {
      api.createRecord('ca87194a', component.options)
    } else {
      api.reload('ca87194a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ca87194a&", function () {
      api.rerender('ca87194a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/index.vue"
export default component.exports